var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExposureCount = function SvgExposureCount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#20E0A5",
    d: "M6 0h20a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeDasharray: "0,0",
    strokeWidth: 0.6,
    d: "M16 11.385c3.325 0 6.353 3.23 7.51 4.615-1.157 1.385-4.185 4.615-7.51 4.615S9.647 17.385 8.49 16c1.157-1.385 4.185-4.615 7.51-4.615ZM16 10c-4.126 0-7.622 3.937-8.801 5.432a.91.91 0 0 0 0 1.135C8.379 18.063 11.874 22 16 22s7.622-3.937 8.801-5.433a.91.91 0 0 0 0-1.135C23.622 13.937 20.126 10 16 10Zm0 4.615c.745 0 1.35.62 1.35 1.385s-.605 1.385-1.35 1.385-1.35-.62-1.35-1.385.605-1.385 1.35-1.385Zm0-1.384a2.7 2.7 0 0 0-2.494 1.71 2.82 2.82 0 0 0 .585 3.017 2.65 2.65 0 0 0 2.942.6C18.042 18.13 18.7 17.12 18.7 16c0-1.53-1.208-2.769-2.7-2.769Z"
  }))));
};
export default SvgExposureCount;